var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlusMenu = function SvgPlusMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0064 9.00012C17.0064 8.44784 16.5586 8.00012 16.0064 8.00012C15.4541 8.00012 15.0064 8.44784 15.0064 9.00012V15.0022H8.99951C8.44723 15.0022 7.99951 15.4499 7.99951 16.0022C7.99951 16.5545 8.44723 17.0022 8.99951 17.0022H15.0064V22.9999C15.0064 23.5521 15.4541 23.9999 16.0064 23.9999C16.5586 23.9999 17.0064 23.5521 17.0064 22.9999V17.0022H23.0005C23.5528 17.0022 24.0005 16.5545 24.0005 16.0022C24.0005 15.4499 23.5528 15.0022 23.0005 15.0022H17.0064V9.00012Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "currentColor",
    strokeWidth: 3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-menu.b7617188.svg";
export { ForwardRef as ReactComponent };